import classNames from 'classnames';
import React, { ReactNode } from 'react';

import { Icon, IconTypes } from '@eika/icon';

import LabelProps from './Props';

export interface ExternalLinkLabelProps extends Omit<LabelProps, 'type' | 'icon'> {
    text: string | ReactNode;
    url: string;
    linkText: string;
    anchorTarget?: '_self' | '_blank' | '_parent' | '_top';
}

const ExternalLinkLabel = ({
    id,
    text,
    url,
    linkText,
    anchorTarget,
    className,
    ...rest
}: ExternalLinkLabelProps): JSX.Element => {
    return (
        <span id={id} className={classNames('sgw-label external-link', className)} {...rest}>
            <span>
                {text}
                <a href={url} target={anchorTarget} rel={anchorTarget ? 'noopener' : undefined}>
                    {linkText}
                    <span className="icon-container">
                        <Icon type={IconTypes.ExternalLink} />
                    </span>
                </a>
            </span>
        </span>
    );
};

export default ExternalLinkLabel;
